import {
  Select as RawSelect,
  SelectProps as RawSelectProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface SelectInputProps extends RawSelectProps {
  type: 'select';
  name: string;
}

export default function SelectInput(props: SelectInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    type,
    error,
    placeholder,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;
  const _placeholder = React.useMemo(() => {
    if (_disabled) return undefined;
    return placeholder;
  }, [_disabled, placeholder]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawSelect
      {...rest}
      {...field}
      type={type}
      value={field.value}
      placeholder={_placeholder}
      onChange={(value, option) => {
        field.onChange(value);
        onChange?.(value, option);
      }}
      disabled={_disabled}
      error={_error}
      styles={{
        option: {
          fontSize: 16,
        },
        ...rest.styles,
      }}
      withAsterisk={withAsterisk}
    />
  );
}
